module.exports = __webpack_public_path__ + "img/img-1.e4d8fab7.png";